import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../../helpers";

export interface NotebookDetailResponse {
  id: number;
  name: string;
  tags: string[];
  owner: number;
  more: Record<string, unknown>;
  createdat: string;
  modifiedat: string;
  [key: string]: unknown;
}

export const useGetNotebook = (notebook_id: number | null | undefined) => {
  const rootStore = useStore();
  const id = notebook_id != null ? Number(notebook_id) : null;
  const isEnabled = Boolean(id && !Number.isNaN(id));

  return useQuery({
    queryKey: ["notebooks", "detail", id],
    queryFn: async () => {
      const res = await rootStore.apiRequestHandler(
        "tars/notebooks/get",
        { notebook_id: id },
        "Failed to fetch notebook"
      );
      return res.data as NotebookDetailResponse;
    },
    enabled: isEnabled,
    refetchOnMount: "always",
  });
};
